// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"200221af","845":"57b85c7a"}[chunkId] + ".chunk.js";
};